import React from "react";
import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Stack, InputGroup } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { IsNotNullAndGreaterThanZero } from "../../utils/StringUtils";
import { DeckRecordOtherContext } from "../../pages/DeckRecords/Edit_Deck_Record_Other";
import { parseNumericInput, PercentageValidationRules } from "../../utils/InputValidator";
import ReadWriteFormCheck from "../ReadWriteElements/ReadWriteFormCheck";
import ReadWriteInputGroup from "../ReadWriteElements/ReadWriteInputGroup";

const SheepPantingDeck = ({ rec, triggerClearMissingAffectedDecks, onTriggerClearMissingAffectedDecks }) => {
    const percentageValidationRules = new PercentageValidationRules(false, false);

    const { updateSheepPantingDeck, triggerShowInvalid, data } = useContext(DeckRecordOtherContext);
    const [isMissingPantingScoreThreePercent, setIsMissingPantingScoreThreePercent] = useState(false);
    const [isMissingPantingScoreFourPercent, setIsMissingPantingScoreFourPercent] = useState(false);
    const [isInvalidCombinedPercent, setIsInvalidCombinedPercent] = useState(false);
    const [pantingScoreThreeError, setPantingScoreThreeError] = useState("");
    const [pantingScoreFourError, setPantingScoreFourError] = useState("");
    const [isInvalidPanting, setIsInvalidPanting] = useState(false);

    const updateData = (isAffected, pantingScoreThreePercent, pantingScoreFourPercent) => {
        if (rec.DeckRecord.isEmpty === false) {
            let lIsValid = isValid(isAffected, pantingScoreThreePercent, pantingScoreFourPercent);
            updateSheepPantingDeck(rec.DeckRecord.consignmentDeckID, isAffected, pantingScoreThreePercent, pantingScoreFourPercent, lIsValid);
        }
    }

    // If affected, panting score three percent or panting score four percent must have a value and their combined value can not be more than 100
    const isValid = (isAffected, pantingScoreThreePercent, pantingScoreFourPercent) => {

        let lIsValid = false;
        if (isAffected === true) {
            if (isMissingInputs(pantingScoreThreePercent, pantingScoreFourPercent) === true) {
                lIsValid = false;
            }
            else { // has a value greater than 0 for at least one input
                if (isValidCombinedPercentage(pantingScoreThreePercent, pantingScoreFourPercent) === true) {
                    lIsValid = true;
                }
                else {
                    lIsValid = false;
                }
            }
        }
        return lIsValid;
    }

    const isMissingInputs = (pantingScoreThreePercent, pantingScoreFourPercent) => {
        if (IsNotNullAndGreaterThanZero(pantingScoreThreePercent) === false && IsNotNullAndGreaterThanZero(pantingScoreFourPercent) === false) {
            return true;
        }
        else {
            return false;
        }
    }

    const isValidCombinedPercentage = (valueOne, valueTwo) => {
        if (Number(valueOne) + Number(valueTwo) <= 100) {
            return true;
        }
        else {
            return false;
        }
    }

    useEffect(() => {
        // we do not need to run this on first load
        if (triggerShowInvalid >= 0) {
            setIsInvalidPanting(!data.sheepPantingValid);

            if (isMissingInputs(rec.DeckRecord.pantingScoreThreePercent, rec.DeckRecord.pantingScoreFourPercent) === true) {
                let lMissingError = "A percentage greater than 0 is requried for panting score 3+ or panting score 4+, or uncheck this deck.";
                setPantingScoreFourError(lMissingError);
                setPantingScoreThreeError(lMissingError);
                setIsMissingPantingScoreThreePercent(true);
                setIsMissingPantingScoreFourPercent(true);
            }
            else if (isValidCombinedPercentage(rec.DeckRecord.pantingScoreThreePercent, rec.DeckRecord.pantingScoreFourPercent) === false) {
                let lCombinedPercentageError = "The combined percentage can not be greather than 100.";
                setIsInvalidCombinedPercent(true);
                setPantingScoreFourError(lCombinedPercentageError);
                setPantingScoreThreeError(lCombinedPercentageError);
            }
            else { // No error
                setPantingScoreFourError("");
                setPantingScoreThreeError("");
                setIsMissingPantingScoreThreePercent(false);
                setIsMissingPantingScoreFourPercent(false);
                setIsInvalidCombinedPercent(false);
                setPantingScoreFourError("");
                setPantingScoreThreeError("");
            }
        }
    }, [triggerShowInvalid]);

    useEffect(() => {
        // we do not need to run this on first load
        if (triggerClearMissingAffectedDecks >= 0) {
            setIsInvalidPanting(false);
        }
    }, [triggerClearMissingAffectedDecks]);

    return (
        <Row key={`sheepPantingDeck_${rec.DeckRecord.consignmentDeckID}`} className="pb-3 pt-3 gray-border-top">
            <Col xs={4}>
                <Stack direction="horizontal" gap={4}>
                    <Form>
                        <Form.Group>
                            <ReadWriteFormCheck labelstacked={false} id={`pantingCheck_${rec.DeckRecord.consignmentDeckID}`} checked={rec.hasSheepPanting}
                                onChange={(e) => {
                                    onTriggerClearMissingAffectedDecks();
                                    setIsMissingPantingScoreThreePercent(false);
                                    setIsMissingPantingScoreFourPercent(false);
                                    setIsInvalidCombinedPercent(false);
                                    setIsInvalidPanting(false);
                                    updateData(e.target.checked, rec.DeckRecord.pantingScoreThreePercent, rec.DeckRecord.pantingScoreFourPercent);
                                }}
                                isInvalid={isInvalidPanting && !rec.DeckRecord.isEmpty}
                                label={rec.ConsignmentDeck.deckName}
                                disabled={rec.DeckRecord.isEmpty}
                            />
                        </Form.Group>
                        {
                            isInvalidPanting && !rec.DeckRecord.isEmpty ? (
                                <div className="validation-error-tooltip">
                                    <Tooltip
                                        anchorSelect={`#pantingCheck_${rec.DeckRecord.consignmentDeckID}`}
                                        place="top"
                                        variant="error"
                                        content="One ore more decks must be selected, or select no."
                                    />
                                </div>
                            ) : null
                        }
                    </Form>
                </Stack>
            </Col>
            <Col xs={4}>
                {
                    rec.hasSheepPanting && !rec.DeckRecord.isEmpty ?
                        <Form.Group>
                            <ReadWriteInputGroup readonlyclasses='text-13-400 secondary-grey'>
                                <Form.Control
                                    id={`sheepPantingScoreFourPercent_${rec.DeckRecord.consignmentDeckID}`}
                                    value={rec.DeckRecord.pantingScoreFourPercent}
                                    onChange={(e) => {
                                        setIsMissingPantingScoreFourPercent(false);
                                        setIsMissingPantingScoreThreePercent(false);
                                        setIsInvalidCombinedPercent(false);
                                        parseNumericInput(e, percentageValidationRules);
                                        updateData(rec.hasSheepPanting, rec.DeckRecord.pantingScoreThreePercent, e.target.value);
                                    }}
                                    className="inputGroupWithAppend errorLeft"
                                    isInvalid={(isMissingPantingScoreFourPercent || isInvalidCombinedPercent) && !rec.DeckRecord.isEmpty}
                                    disabled={rec.DeckRecord.isEmpty}
                                />
                                <InputGroup.Text className={`inputGroupAppend ${(isMissingPantingScoreFourPercent || isInvalidCombinedPercent) && !rec.DeckRecord.isEmpty ? "invalidAppend" : ""}`}>%</InputGroup.Text>
                                {
                                    (isMissingPantingScoreFourPercent || isInvalidCombinedPercent) && !rec.DeckRecord.isEmpty ? (
                                        <div className="validation-error-tooltip">
                                            <Tooltip
                                                anchorSelect={`#sheepPantingScoreFourPercent_${rec.DeckRecord.consignmentDeckID}`}
                                                place="top"
                                                variant="error"
                                                content={pantingScoreFourError}
                                            />
                                        </div>
                                    ) : null
                                }
                            </ReadWriteInputGroup>
                        </Form.Group>
                        : null
                }
            </Col>
            <Col xs={4}>
                {
                    rec.hasSheepPanting && !rec.DeckRecord.isEmpty ?
                        <Form.Group>
                            <ReadWriteInputGroup readonlyclasses='text-13-400 secondary-grey'>
                                <Form.Control
                                    id={`sheepPantingScoreThreePercent_${rec.DeckRecord.consignmentDeckID}`}
                                    value={rec.DeckRecord.pantingScoreThreePercent}
                                    onChange={(e) => {
                                        setIsMissingPantingScoreThreePercent(false);
                                        setIsMissingPantingScoreFourPercent(false);
                                        setIsInvalidCombinedPercent(false);
                                        parseNumericInput(e, percentageValidationRules);
                                        updateData(rec.hasSheepPanting, e.target.value, rec.DeckRecord.pantingScoreFourPercent);
                                    }}
                                    className="inputGroupWithAppend errorLeft"
                                    isInvalid={(isMissingPantingScoreThreePercent || isInvalidCombinedPercent) && !rec.DeckRecord.isEmpty}
                                    disabled={rec.DeckRecord.isEmpty}
                                />
                                <InputGroup.Text className={`inputGroupAppend ${(isMissingPantingScoreThreePercent || isInvalidCombinedPercent)&& !rec.DeckRecord.isEmpty ? "invalidAppend" : ""}`}>%</InputGroup.Text>
                                {
                                    isMissingPantingScoreThreePercent || isInvalidCombinedPercent ? (
                                        <div className="validation-error-tooltip">
                                            <Tooltip
                                                anchorSelect={`#sheepPantingScoreThreePercent_${rec.DeckRecord.consignmentDeckID}`}
                                                place="top"
                                                variant="error"
                                                content={pantingScoreThreeError}
                                            />
                                        </div>
                                    ) : null
                                }
                            </ReadWriteInputGroup>
                        </Form.Group>
                        : null
                }
            </Col>
        </Row>
    )
};

export default SheepPantingDeck;